import * as React from 'react'
import cx from 'classnames'
import * as styles from './radio.button.styl'

export interface RadioButtonProps {
  className?: string
  name: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  value: React.ReactText
  checked: boolean
  label: React.ReactNode
  disabled?: boolean
}

const RadioButton: React.FC<RadioButtonProps> = ({
  name,
  className,
  onChange,
  value,
  checked,
  disabled,
  label
}: React.PropsWithChildren<RadioButtonProps>) => {
  function handleChange(
    event: React.ChangeEvent<HTMLInputElement> &
      React.KeyboardEvent<HTMLInputElement>
  ) {
    if (!disabled && onChange && typeof onChange === 'function') {
      onChange(event)
    }
  }
  return (
    <label
      className={cx('radioContainer', styles.radioContainer, className, {
        disabled
      })}
    >
      <input
        type="radio"
        name={name}
        disabled={disabled}
        onChange={handleChange}
        value={value}
        checked={checked}
        id={name}
      />
      <span className={cx('radioCheckmark', styles.radioCheckmark)} />
      {label}
    </label>
  )
}

export default RadioButton
